<div class="w-full mx-auto p-5" *ngIf="note">
    <div class="max-w-4xl mx-auto">
        <!-- Header -->
        <div class="flex justify-between items-center mb-6">
            <div>
                <h1 class="text-2xl font-bold text-gray-800">Detalle de Nota Débito</h1>
                <p class="text-gray-500 mt-1">{{ note.documentNumber }}</p>
            </div>
            <div class="flex gap-2">
                <!-- Botón descargar PDF -->
                <button (click)="downloadPdf()" [disabled]="isDownloadingPdf"
                    class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition flex items-center gap-2 disabled:opacity-50">
                    <svg *ngIf="!isDownloadingPdf" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                    </svg>
                    <svg *ngIf="isDownloadingPdf" class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg"
                        fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                        </path>
                    </svg>
                    Descargar PDF
                </button>
                <button (click)="goBack()"
                    class="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition">
                    Volver
                </button>
            </div>
        </div>

        <!-- Content -->
        <div class="bg-white rounded-xl shadow-md p-6 space-y-6">

            <!-- Status Badge -->
            <div class="flex items-center gap-2">
                <span class="px-3 py-1 rounded-full text-sm font-medium" [ngClass]="{
          'bg-red-100 text-red-700': note.isCancelled,
          'bg-green-100 text-green-700': !note.isCancelled
        }">
                    <i class="fas" [ngClass]="{
            'fa-ban': note.isCancelled,
            'fa-check-circle': !note.isCancelled
          }"></i>
                    {{ note.isCancelled ? 'ANULADA' : 'Activa' }}
                </span>
            </div>

            <!-- Main Info -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label class="block text-sm font-medium text-gray-500 mb-1">Número de Documento</label>
                    <p class="text-lg font-semibold text-gray-800">{{ note.documentNumber }}</p>
                </div>

                <div>
                    <label class="block text-sm font-medium text-gray-500 mb-1">Fecha del Documento</label>
                    <p class="text-lg font-semibold text-gray-800">{{ note.documentDate | date:'mediumDate' }}</p>
                </div>

                <div>
                    <label class="block text-sm font-medium text-gray-500 mb-1">Fecha de Creación</label>
                    <p class="text-lg font-semibold text-gray-800">{{ note.createdAt | date:'mediumDate' }}</p>
                </div>

                <div>
                    <label class="block text-sm font-medium text-gray-500 mb-1">Monto</label>
                    <p class="text-2xl font-bold text-green-600">+{{ note.amount | currency }}</p>
                </div>

                <div>
                    <label class="block text-sm font-medium text-gray-500 mb-1">Banco</label>
                    <p class="text-lg font-semibold text-gray-800">
                        {{ note.bank?.bankName || 'N/A' }}<br>
                        <span class="text-sm text-gray-500">{{ note.bank?.accountNumber }}</span>
                    </p>
                </div>
            </div>

            <!-- Concepto -->
            <div>
                <label class="block text-sm font-medium text-gray-500 mb-1">Concepto</label>
                <p class="text-gray-800">{{ note.concept }}</p>
            </div>

            <!-- Observaciones -->
            <div *ngIf="note.observations">
                <label class="block text-sm font-medium text-gray-500 mb-1">Observaciones</label>
                <p class="text-gray-800 bg-gray-50 p-3 rounded-lg">{{ note.observations }}</p>
            </div>

            <!-- Related Entities -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-6 pt-4 border-t">
                <div *ngIf="note.project">
                    <label class="block text-sm font-medium text-gray-500 mb-1">Proyecto</label>
                    <p class="text-gray-800">{{ note.project.projectId }} - {{ note.project.name }}</p>
                </div>

                <div *ngIf="note.participant">
                    <label class="block text-sm font-medium text-gray-500 mb-1">Participante</label>
                    <p class="text-gray-800">{{ note.participant.firstName }} {{ note.participant.lastName }}</p>
                </div>

                <div *ngIf="note.thirdParties">
                    <label class="block text-sm font-medium text-gray-500 mb-1">Tercero</label>
                    <p class="text-gray-800">{{ note.thirdParties.firstName }} {{ note.thirdParties.lastName }}</p>
                </div>
            </div>

            <!-- Cancellation Info -->
            <div *ngIf="note.isCancelled" class="bg-red-50 border border-red-200 rounded-lg p-4">
                <h3 class="font-semibold text-red-900 mb-2">Información de Anulación</h3>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                    <div>
                        <span class="text-red-700 font-medium">Fecha:</span>
                        <span class="text-red-900 ml-2">{{ note.cancelledAt | date:'medium' }}</span>
                    </div>
                    <div>
                        <span class="text-red-700 font-medium">Anulado por:</span>
                        <span class="text-red-900 ml-2">{{ note.cancelledBy }}</span>
                    </div>
                    <div class="md:col-span-2">
                        <span class="text-red-700 font-medium">Motivo:</span>
                        <span class="text-red-900 ml-2">{{ note.cancellationReason }}</span>
                    </div>
                </div>
            </div>

            <!-- Audit Info -->
            <div class="pt-4 border-t">
                <h3 class="font-semibold text-gray-700 mb-3">Información de Auditoría</h3>
                <app-audit-info [auditData]="{
                    createdBy: note.createdBy,
                    createdAt: note.createdAt,
                    updatedBy: note.updatedBy,
                    updatedAt: note.updatedAt
                }" layout="vertical" size="md">
                </app-audit-info>
            </div>
        </div>
    </div>
</div>